import { botApi } from './botApi'
import { IGetBalancesResponse } from './types'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
export const balancesApi = botApi.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getBalances: query<IGetBalancesResponse, { onlyForEnabled?: boolean }>({
      query: params => ({ url: `balance/all`, method: 'GET', params }),
      transformErrorResponse: res => {
        if (res.status === 401) {
          cookies.remove('TOKEN')
        }
      },
    }),
  }),
})

export const { useGetBalancesQuery } = balancesApi
